// src/app/services/goals.service.ts
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api.base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoalsService extends ApiBaseService {
  constructor(public http: HttpClient) {
    super(http, '/goals');
  }

  clone(id: number): Observable<any> {
    return this.http.post(`${environment.apiUrl}/goals/${id}/clone`, {});
  }
  
  getPeriods(id: number, filter?: string, timezone?: string): Observable<any> {
    let params = new HttpParams();
    if (filter) {
      params = params.set('filter', filter);
    }
    if (timezone) {
      params = params.set('timezone', timezone);
    }
    return this.http.get(`${environment.apiUrl}/goals/${id}/periods`, { params });
  }

  getPeriodRecords(goalId: number, periodId: number, params: any = {}): Observable<any> {
    let httpParams = new HttpParams();
    if (params.page) {
      httpParams = httpParams.set('page', params.page.toString());
    }
    if (params.limit) {
      httpParams = httpParams.set('limit', params.limit.toString());
    }
    return this.http.get(`${environment.apiUrl}/goals/${goalId}/periods/${periodId}/records`, { params: httpParams });
  }

  exportPeriodRecords(goalId: number, periodId: number, format: 'xlsx' | 'csv' = 'xlsx'): Observable<Blob> {
    return this.http.post(
      `${environment.apiUrl}/goals/${goalId}/periods/${periodId}/export`,
      { format },
      { responseType: 'blob' }
    );
  }

  getMyGoals(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/goals/my-goals`);
  }
}